  import React, { useEffect, useState } from "react";
  import ReusableTable from "../../../../components/common/table";
  import { Button, Popconfirm, Space } from "antd";
  import { ReactComponent as AddSvg } from "../../../../assets/images/add.svg";
  import FilterComponent from "../../../../components/common/filter";
  import { useNavigate } from "react-router";
  import ConfirmModal from "../../../../components/common/alert-popup";
  import { ReactComponent as ViewSvg } from "../../../../assets/images/action/view.svg";
  import { ReactComponent as DeleteSvg } from "../../../../assets/images/action/delete.svg";
  import { ReactComponent as EditSvg } from "../../../../assets/images/action/edit.svg";
  import { ReactComponent as DisableSvg } from "../../../../assets/images/action/Shield Cross.svg";
  import CommonFilter from "../../../../components/common/filter";
  import { useDispatch, useSelector } from "react-redux";
  import { deleteCelebrityCategory, listCelebrityCategory, updateCelebrityCategory } from "../../../../redux/reducer/CelebrityCategorySlice";
  import dayjs from "dayjs";
import trimSearchValue, { useDebounce } from "../../../../customHooks";
import { useSearchParams } from "react-router-dom";

  const ManageCelebrity = () => {
    const [filteredData, setFilteredData] = useState(null);
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const [refereshData, setRefereshData] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [disableId, setDisableId] = useState(null);
    const [disableStatus, setDisableStatus] = useState(null)
    const [currentPage, setCurrentPage] = useState(1);
    // const [tableParams, setTableParams] = useState({
    //   page: 1,
    //   size: 10,
    //   search_value: "",
    //   search_key: "",
    //   status: undefined,
    //   position: undefined,
      
    // });

      // set page refersh 
      const [searchParams, setSearchParams] = useSearchParams();
      // Convert URLSearchParams to usable object
    const getInitialParams = () => {
      const page = parseInt(searchParams.get("page")) || 1;
      const size = parseInt(searchParams.get("size")) || 10;
      const search_key = searchParams.get("search_key") || "all";
      const search_value = searchParams.get("search_value") || "";
      const status = searchParams.get("status");
      const position = searchParams.get("position");
    
      return {
        page,
        size,
        search_key,
        search_value,
        status: status !== null ? Number(status) : undefined,
        position: position !== null ? Number(position) : undefined,
      };
    };
    
    const [tableParams, setTableParams] = useState(getInitialParams());
    
    useEffect(() => {
      const params = {
        page: tableParams.page,
        size: tableParams.size,
        search_key: tableParams.search_key,
        search_value: tableParams.search_value,
      };
    
      if (tableParams.status !== undefined) params.status = tableParams.status;
      if (tableParams.position !== undefined) params.position = tableParams.position;
    
      setSearchParams(params);
    }, [tableParams, setSearchParams]);
    
      // set page refersh end
  
    const {listCategory, listCategoryCount,  listCategoryLoading} = useSelector((prev) => prev?.celebrityCategory)
    
    const [modalConfig, setModalConfig] = useState({
      open: false,
      actionType: "",
    });
    const handleDateFilter = (dates, dateStrings) => {
      if (!dates) {
        setFilteredData(dataSource);
        return;
      }
      const [startDate, endDate] = dateStrings;
      const filtered = dataSource.filter((item) => {
        const itemDate = new Date(item.date_added);
        return itemDate >= new Date(startDate) && itemDate <= new Date(endDate);
      });
      setFilteredData(filtered);
    };

    const debouncedSearchValue = useDebounce(tableParams.search_value, 500);
 



// pagination


  const paginationConfig = {
    pageSizeOptions: ["10", "20", "50"], 
    showSizeChanger: true, 
    showQuickJumper: true, 
    total: listCategoryCount || 1, 
    current: tableParams.page, 
    pageSize: tableParams.size, 
    onChange: (page, pageSize) => {
      setCurrentPage(page); 
      setTableParams((prev) => ({ ...prev, page, size: pageSize }));
    },
  };
  
  const handleTableChange = (pagination) => {
    setTableParams((prev) => ({
      ...prev,
      page: pagination.current,
      size: pagination.pageSize,
    }));
  };

  // pagination end




    const showModal = (actionType) => {
      setModalConfig({ open: true, actionType });
    };

    const closeModal = () => {
      setModalConfig({ open: false, actionType: "" });
    };


    // const handleSearch = (searchText) => {
    //   const filtered = dataSource.filter((item) =>
    //     item.tenant_name.toLowerCase().includes(searchText.toLowerCase())
    //   );
    //   setFilteredData(filtered);
    // };

    useEffect(()=>{
      dispatch(listCelebrityCategory(trimSearchValue(tableParams)))
    },[dispatch, refereshData, disableId,
      tableParams.page, tableParams.size,
      debouncedSearchValue,
      tableParams.status,
      tableParams.position,
    ])

 
  

   
    const columns = [
      {
        title: "Sr. No.",
        dataIndex: "sr_no",
        key: "sr_no",
        render: (text, record, index) => index + 1, 
        width: "100px"
      },
      {
        title: "Celebrity Name",
        dataIndex: "name_en",
        key: "celebrity_name",
        type: "search",
      },
      {
        title: "Image",
        dataIndex: "image_url",
        key: "banner_media",
        render: (image_url) => (
          <div>
            {image_url ? (
              <img
                src={`${process.env.REACT_APP_IMAGE_URL}/${image_url}`}
                alt="Banner"
                style={{ width: "100px", height: "50px", objectFit:"contain", borderRadius: "8px" }}
              />
            ) : (
              "No Image"
            )}
          </div>
        ),
      },
      {
        title: "No. Of Podcasts",
        dataIndex: "total_podcast",
        key: "nos_podcast",
        // type: "search",
        width: "200px",
        render: (total_podcast) => total_podcast ?? "0",
      },

      {
        title: "Date Added",
        dataIndex: "created_at",
        key: "date_added",
        // type: "date",
        // render: (date) => dayjs(date).format("MM-DD-YYYY"),
        render: (date) => {
          const dateObject = new Date(date);
          const day = String(dateObject.getUTCDate()).padStart(2, '0');       
          const month = String(dateObject.getUTCMonth() + 1).padStart(2, '0'); 
          const year = dateObject.getUTCFullYear();                          
          return `${month}-${day}-${year}`;
        },
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        type: "select",
        width: "90px",
        render: (status) => (status === 1 ? <p className="active-status">Active</p> : <p className="inactive-status">Inactive</p>), // Check if status is 1
        options: [
          { label: "Active", value: 1 },
          { label: "Inactive", value: 0 },
        ],
      },
    ];

    const dataSource = [
      {
        key: "1",
        sr_no: "1",
        celebrity_name: "Acme Corp",
        nos_podcast: 50,
        status: "Active",
        date_added: "2024-02-15",
      },
      {
        key: "2",
        sr_no: "2",
        celebrity_name: "Tech Solutions",
        nos_podcast: 120,
        status: "Inactive",
        date_added: "2023-05-10",
      },
      {
        key: "3",
        sr_no: "3",
        celebrity_name: "Innovate Inc.",
        nos_podcast: 80,
        status: "Active",
        date_added: "2024-03-01",
      },
    ];

    


    const handleDeleteClick = (id) => {
      
      setDeleteId(id);
      showModal("delete"); // Open the modal
    };

    const handleConfirm = async () => {
      try {
        if (modalConfig.actionType === "delete" && deleteId) {
          await dispatch(deleteCelebrityCategory(deleteId));
        } else if (modalConfig.actionType === "disable" && disableId) {
          await dispatch(updateCelebrityCategory({ id: disableId, data: { status: 0 } }));     
        }else if (modalConfig.actionType === "enable"){
          await dispatch(updateCelebrityCategory({ id: disableId, data: { status: 1 } }));
        }
      } catch (error) {
        console.error("Action failed:", error);
      }finally{
        setRefereshData((prev) => !prev);
        setDisableId(null);
      }
      closeModal();
    };

    const handleDisableClick = (id, status) => {
      if(status === 1){
        showModal("disable", id, status)
      }else if(status === 0){
        showModal("enable", id, status)
      } else{
        
      }    
      setDisableStatus(status)
      setDisableId(id);
      // showModal("disable"); // Open the modal for confirmation
    };
    

    const actionItems = (record)=> [
      {
        key: "view",
        label: (
          <>
            <ViewSvg style={{ marginRight: 8 }} />
            View Details
          </>
        ),
        // onClick: (record) => navigate("view-celebrity"),
        onClick: (record) => navigate("view-celebrity", { state: { celebrityData: record } }),
      },
      {
        key: "edit",
        label: (
          <>
            <EditSvg style={{ marginRight: 8, color: "red" }} />
            Edit Details
          </>
        ),
        // onClick: (record) => navigate("add-celebrity"),
        onClick: (record) => navigate("edit-celebrity", { state: { editData: record } }),
      },
      {
        key: "disable",
        label: (
          <>
        
            <DisableSvg style={{ marginRight: 8, color: `${record.status === 1 ? "green" : "red" }`}} />
          {record.status === 1 ?   "Disable": "Enable"}
          </>

        ),
        // onClick: () => showModal("disable"),
        onClick: (record) => handleDisableClick(record.id, record?.status),
        // onClick:
        //   record?.status === 1
        //     ? () => showModal("deactivate", user.id, user.status)
        //     : () => showModal("activate", user.id, user.status),
      },
      {
        key: "delete",
        label: (
          <>
            <DeleteSvg style={{ marginRight: 8, color: "red" }} />
            Delete Celebrity
          </>
        ),
        onClick: (record) => handleDeleteClick(record.id), 
      },
    ];
  
    const handleFilterChange = (key, value, reset = false) => {
      setTableParams((prev) => {
        if (reset) {
          return {
            ...prev,
            page: 1,
            search_key: "",
            search_value: "",
            status: undefined,
            position: undefined,
          };
        }
        if (key === "status" || key === "position") {
          return {
            ...prev,
            [key]: value === 0 ? 0 : (value === 1 ? 1 : undefined),
            search_key: "",
            search_value: "",
          };
        }
        return {
          ...prev,
          search_key: key,
          search_value: value,
          status: undefined,
          position: undefined,
        };
      });
    };
   
    return (
      <div>
        <div className="addBx">
          <div className="filterBx">
            <Space>
              <CommonFilter
                columns={columns}
                onFilterChange={handleFilterChange}
                searchValue={tableParams.search_value}
              />
            </Space>
          </div>
          <Button
            type="primary"
            icon={<AddSvg />}
            onClick={() => navigate("add-celebrity")}
          >
            Add Celebrity
          </Button>
        </div>
        <div className="tableHeading">List of Celebrity Added</div>
        <ReusableTable
          columns={columns}
          dataSource={listCategory}
          loading={listCategoryLoading}
          paginationConfig={paginationConfig}
          onChange={handleTableChange} 
          actionItems={(record) => actionItems(record)}
        />
        <ConfirmModal
          titlePrefix="Celebrity"
          messagePrefix="Celebrity"
          open={modalConfig.open}
          onClose={closeModal}
          onConfirm={handleConfirm}
          actionType={modalConfig.actionType}
        />
      </div>
    );
  };

  export default ManageCelebrity;
